import { Activity, Users, BarChart3 } from "lucide-react";

interface SalepageMonitoringProps {
  stats: any;
  recentUsers: any[];
}

export default function SalepageMonitoring({ stats, recentUsers }: SalepageMonitoringProps) {
  return (
    <div className="space-y-6">
      <div className="grid md:grid-cols-3 gap-6">
        <div className="bg-white rounded-2xl shadow-lg p-6 border border-gray-100">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-12 h-12 bg-gradient-to-br from-green-500 to-emerald-500 rounded-xl flex items-center justify-center">
              <Activity className="w-6 h-6 text-white" />
            </div>
            <div>
              <p className="text-sm text-gray-500">สถานะระบบ</p>
              <p className="text-lg font-bold text-green-600">ปกติ</p>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-lg p-6 border border-gray-100">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-xl flex items-center justify-center">
              <Users className="w-6 h-6 text-white" />
            </div>
            <div>
              <p className="text-sm text-gray-500">ผู้ใช้ออนไลน์</p>
              <p className="text-lg font-bold text-gray-900">{Math.floor(stats.totalUsers * 0.3)}</p>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-lg p-6 border border-gray-100">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-pink-500 rounded-xl flex items-center justify-center">
              <BarChart3 className="w-6 h-6 text-white" />
            </div>
            <div>
              <p className="text-sm text-gray-500">Uptime</p>
              <p className="text-lg font-bold text-gray-900">99.9%</p>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-2xl shadow-lg p-8 border border-gray-100">
        <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-2">
          <Activity className="w-6 h-6 text-emerald-600" />
          กิจกรรมล่าสุด
        </h2>

        <div className="space-y-4">
          {recentUsers.slice(0, 10).map((user, index) => (
            <div key={index} className="flex items-center gap-4 p-4 bg-gray-50 rounded-lg">
              <div className="w-10 h-10 bg-gradient-to-br from-emerald-500 to-cyan-500 rounded-full flex items-center justify-center text-white font-semibold">
                {user.email?.[0]?.toUpperCase() || 'U'}
              </div>
              <div className="flex-1">
                <p className="font-medium text-gray-900">{user.displayName || user.email}</p>
                <p className="text-sm text-gray-500">
                  เข้าร่วมระบบ {user.salePageSubscription?.startDate?.toDate().toLocaleDateString('th-TH')}
                </p>
              </div>
              <span className="text-xs text-gray-400">
                {user.salePageSubscription?.status === 'trial' ? 'ทดลองใช้' : 'Active'}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
